import { Box, Flex } from '@chakra-ui/react';
import React from 'react';

import { BackupOriginatorGlobalNav } from '~/backup/originator/domains/page/ui/BackupOriginatorGlobalNav';
import { AppHeader } from '~/packages/common-frontend/layout/Header';

type Props = { children: React.ReactNode };
export const BackupOriginatorTemplate = ({
  children,
}: Props): React.ReactElement => {
  return (
    <>
      <AppHeader />
      <Flex grow={1} pt="84px">
        <BackupOriginatorGlobalNav />
        <Box width="100%" overflowX="auto">
          {children}
        </Box>
      </Flex>
    </>
  );
};
